// Close the drawer before opening Klaviyo so its focus trap is released.
if (!customElements.get('sidebar-discount-offer')) {
  customElements.define('sidebar-discount-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.onOfferClick) return;
      this.onOfferClick = async (event) => {
        const button = event.target.closest('button[data-form-id]');
        if (!button || button.disabled) return;
        button.disabled = true;
        try {
          const drawer = this.closest('header-sidebar');
          if (drawer?.open) await drawer.hide();
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', button.dataset.formId]);
        } finally {
          button.disabled = false;
        }
      };
      this.addEventListener('click', this.onOfferClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onOfferClick);
      this.onOfferClick = null;
    }
  });
}
